export default function renderContentfulImports(
  localization: boolean = false,
  hasRichText: boolean = true,
): string {
  return `
    // THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT.

    import { ${localization ? "" : "Asset, "}Entry } from 'contentful'
    ${hasRichText ? "import { Document } from '@contentful/rich-text-types'" : ""}
  `
}
